export default __webpack_public_path__ + "static/media/icon-profile.53bd55ac.svg";